export default {
  "content": "<g clip-path=\"url(#clip0_979_1813)\"><path d=\"M13 4.824H5a3 3 0 00-3 3v20a3 3 0 003 3h20a3 3 0 003-3v-8\" stroke=\"#5C6270\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.94 20.885a1.5 1.5 0 010-2.121l14.439-14.44H21a1.5 1.5 0 010-3h9a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-3 0V6.446L14.06 20.885a1.5 1.5 0 01-2.12 0z\" fill=\"#5C6270\"/></g><defs><clipPath id=\"clip0_979_1813\"><path fill=\"#fff\" transform=\"translate(0 .824)\" d=\"M0 0h32v32H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "33",
    "viewBox": "0 0 32 33",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};